// Stage 1 of the routing migration (docs/plans/toasty-soaring-pudding.md).
// See events.$id.tsx for the detail half of this pair.
import React from 'react';
import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { cacheEntity, pathForRoute } from '../lib/router';
import { EventsPage } from '../modules/events/EventsPage';

export const Route = createFileRoute('/events/')({
  component: EventsIndexRoute,
});

function EventsIndexRoute() {
  const navigate = useNavigate();
  const navToEvent = (e) => { cacheEntity('event-detail', e); navigate({ to: pathForRoute('event-detail', e) }); };
  const navToRef = (active) => (ref) => {
    const id = typeof ref === 'string' ? ref : (ref?.routeId || ref?.id || ref?.code || '');
    if (!id) return;
    navigate({ to: pathForRoute(active, { id }) });
  };
  return (
    <EventsPage
      onSelectEvent={navToEvent}
      onNavOrganizer={navToRef('organizer-detail')}
      onNavVenue={navToRef('venue-detail')}
    />
  );
}
